import React from 'react';
import { Loan } from '../types';
import { getDaysInRetention } from '../utils/retention';
interface UpNextStripProps {
  loans: Loan[];
  avgDays: number;
  revivedThisWeek: number;
  activeClaims: number;
}
export function UpNextStrip({
  loans,
  avgDays,
  revivedThisWeek,
  activeClaims
}: UpNextStripProps) {
  const stats = [{
    label: 'Avg. Days',
    value: avgDays.toFixed(1)
  }, {
    label: 'Revived Wk',
    value: revivedThisWeek
  }, {
    label: 'Active Claim',
    value: activeClaims
  }];
  return <section aria-label="Up next in the retention queue" className="flex items-center gap-4 border-t border-brand-200 bg-brand-50/60 px-5 py-3 sm:gap-5 sm:px-8" data-id="element-284" data-mp="380npa1m912qw">
      <h2 className="flex shrink-0 items-center gap-2 border-r border-brand-200 pr-4 text-[11px] font-medium uppercase tracking-[0.1em] text-brand-400" data-id="element-285" data-mp="3ht1tr24pongr">
        Up Next
        <span className="rounded-full bg-brand-500 px-2 py-0.5 text-[11px] font-semibold text-white" data-id="element-286" data-mp="3rriqygu8tyb9">
          {loans.length}
        </span>
      </h2>

      {loans.length === 0 ? <p className="flex-1 text-[13px] text-brand-400" data-id="element-287" data-mp="ejddn5l5j1df">
          Queue is clear — nothing waiting behind this file.
        </p> : <div className="relative flex min-w-0 flex-1 items-center overflow-hidden" style={{
      maskImage: 'linear-gradient(to right, transparent 0, #000 24px, #000 calc(100% - 24px), transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to right, transparent 0, #000 24px, #000 calc(100% - 24px), transparent 100%)'
    }} data-id="element-288" data-mp="jhez1x61vcs2">
          <ul className="flex shrink-0 animate-marquee items-center gap-2.5 pr-2.5 motion-reduce:animate-none" data-id="element-289" data-mp="12a9bokg7ast4">
            {loans.map(loan => <QueueChip key={loan.id} loan={loan} data-id="element-290" data-mp="1c86yd3iewhjm" />)}
          </ul>
          <ul aria-hidden="true" className="flex shrink-0 animate-marquee items-center gap-2.5 pr-2.5 motion-reduce:hidden" data-id="element-291" data-mp="1h6ibbn407862">
            {loans.map(loan => <QueueChip key={`dupe-${loan.id}`} loan={loan} data-id="element-292" data-mp="mjje0kzjpemb" />)}
          </ul>
        </div>}

      <dl className="flex shrink-0 gap-5 border-l border-brand-200 pl-4" data-id="element-293" data-mp="118xs26e2gk81">
        {stats.map(stat => <div key={stat.label} className="text-right" data-id="element-294" data-mp="whfpjdweabky">
            <dd className="text-[15px] font-semibold leading-none tracking-[-0.01em] text-brand-500" data-id="element-295" data-mp="wfmku45ce1fl">
              {stat.value}
            </dd>
            <dt className="mt-1.5 text-[10px] font-medium uppercase tracking-[0.08em] text-brand-300" data-id="element-296" data-mp="15asq920pahhl">
              {stat.label}
            </dt>
          </div>)}
      </dl>
    </section>;
}
function QueueChip({
  loan
}: {
  loan: Loan;
}) {
  return <li className="flex items-center gap-2 whitespace-nowrap rounded-full border border-brand-200 bg-brand-50 py-1.5 pl-3.5 pr-2 text-xs" data-id="element-297" data-mp="1f6cnbrr03m7x">
      <span className="font-medium text-brand-500" data-id="element-298" data-mp="3h0bx28oh5vii">{loan.borrowerName}</span>
      <span className="rounded-full border border-brand-200 bg-white px-2 py-px font-mono text-[10.5px] font-medium text-brand-400" data-id="element-299" data-mp="1whrmco2adq90">
        {getDaysInRetention(loan.dateEntered)}d
      </span>
    </li>;
}